import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Psyclone,
  voices: {
    main: {
      description:
        "calm psychic mezzo, airy precise diction, controlled storm beneath serenity, breathy upper harmonics, intimate telepathic closeness with faint chorus",
      seed: 10613,
      guidance: 0.76,
      loudness: 0.78,
      fx: { doubler: true, reverb: 0.12, eq: "bright" },
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "My ōdachi's sharp. My mind is sharper." },
      { id: "select_2", text: "Psyclone's sword remains sharp." },
      { id: "select_3", text: "They call me Psyclone. That name shall do." },
      { id: "select_4", text: "Sai humbly awaits your command." },
    ],
    spawn: [
      { id: "spawn_1", text: "Shadow and light in perfect harmony!" },
      {
        id: "spawn_2",
        text: "Together, my friends, we will find a flawless balance!",
      },
      {
        id: "spawn_3",
        text: "An illusion can be just as deadly as the real thing!",
      },
      {
        id: "spawn_4",
        text: "Our minds are nearly as sharp as my blades, Emma…",
      },
      {
        id: "spawn_5",
        text: "We have demons to slay. What are we waiting for?",
      },
      {
        id: "spawn_6",
        text: "If we save all timelines, perhaps I can finally return to my own.",
      },
      { id: "spawn_7", text: "One blade pierces minds. The other, hearts." },
      {
        id: "spawn_8",
        text: "We are warriors, no matter what worlds we come from. Do not lose sight of that.",
      },
      {
        id: "spawn_9",
        text: "Clear a path. Unless you wish me to clear your mind… permanently.",
      },
      {
        id: "spawn_10",
        text: "I'm just a sword for hire. This is all so much bigger than me.",
      },
      {
        id: "spawn_11",
        text: "I've fought Oni. Slayed demons. This… should be easy.",
      },
      {
        id: "spawn_12",
        text: "I will not rest until I return to my world once more.",
      },
      {
        id: "spawn_13",
        text: "Everything in this place feels so familiar, and yet so strange.",
      },
      {
        id: "spawn_14",
        text: "Enemies can become friends, but only if we show our foes respect.",
      },
      {
        id: "spawn_15",
        text: "Hmm. It appears some timelines feature a very… different version of me.",
      },
      {
        id: "spawn_16",
        text: "Demons. Yokai and Villains. They all fall by my blade just the same.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I'm back. Mind, body, and soul." },
      { id: "respawn_2", text: "My light cannot be snuffed." },
      { id: "respawn_3", text: "I have reawakened." },
      { id: "respawn_4", text: "I don't give up so easily." },
      { id: "respawn_5", text: "Reborn once more." },
      { id: "respawn_6", text: "My hunt continues." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Watch me soar!" }],
    ult_enemy: [
      {
        id: "ult_enemy",
        text: "蝶の舞を喰らえ! / Chō no mai o kurae! Translation: Feel the Dance of the Butterfly!",
      },
    ],
    ability2: [
      { id: "ability2_1", text: "Farewell." },
      { id: "ability2_2", text: "さよなら! / Sayonara! Translation: Goodbye!" },
      { id: "ability2_3", text: "Out of sight!" },
    ],
    ability1: [
      { id: "ability1_1", text: "Step aside!" },
      {
        id: "ability1_2",
        text: "逃さないわよ! / Nigasanai wa yo! Translation: I won't let you escape!",
      },
      { id: "ability1_3", text: "You're mine!" },
    ],
    kill: [
      { id: "kill_1", text: "Mind over matter." },
      { id: "kill_2", text: "Did that hurt? Good." },
      { id: "kill_3", text: "What a disgrace." },
      { id: "kill_4", text: "よし. / Yoshi. Translation: Alright." },
      { id: "kill_5", text: "You lose, demon." },
    ],
    multikill: [
      { id: "multikill_1", text: "That makes three." },
      { id: "multikill_2", text: "One after another." },
      { id: "multikill_3", text: "They just keep falling." },
      { id: "multikill_4", text: "So many victories!" },
      { id: "multikill_5", text: "No stopping me now." },
      { id: "multikill_6", text: "Five demons dispatched." },
      { id: "multikill_7", text: "It's over at last." },
      { id: "multikill_8", text: "No more demons to slay." },
      { id: "multikill_9", text: "My work is done." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "I needed that." },
      { id: "low_hp_2", text: "Now I might survive this." },
    ],
    healed: [
      { id: "healed_1", text: "That's better." },
      { id: "healed_2", text: "What a difference." },
      { id: "healed_3", text: "This will do nicely." },
      { id: "healed_4", text: "Healing magic? Lovely." },
    ],
  },
} satisfies VoiceScript;

export default script;
